import { ApiDataAdapter } from '@internal-libraries/kheops-ui-lib'
import { get } from 'lodash'
import Stay from '../Classes/Stay'
import { StayDto } from '../Type/StayDto'
import { AffectationApiAdapter } from '../../../dPhospi/vue/Adapters/AffectationApiAdapter'
import { AdmissionTypeApiAdapter } from './AdmissionTypeApiAdapter'

export class StayApiAdapter implements ApiDataAdapter<Stay> {
    public createClass(apiData: StayDto): Stay {
        const affectation = get(apiData, '_ref_curr_affectation')
        const admissionType = get(apiData, '_admission_type')

        const stay = new Stay({
            id: get(apiData, 'id'),
            patientId: get(apiData, 'patient_id'),
            praticienId: get(apiData, 'praticien_id'),
            groupId: get(apiData, 'group_id'),
            type: get(apiData, 'type'),
            entreePreparee: get(apiData, 'entree_preparee'),
            entreeModifiee: get(apiData, 'entree_modifiee'),
            entreePrevue: get(apiData, 'entree_prevue'),
            sortiePrevue: get(apiData, 'sortie_prevue'),
            entreeReelle: get(apiData, 'entree_reelle'),
            sortieReelle: get(apiData, 'sortie_reelle'),
            entree: get(apiData, 'entree'),
            sortie: get(apiData, 'sortie'),
            serviceId: get(apiData, 'service_id'),
            isolationType: get(apiData, 'type_isolement'),
            admissionTypeId: get(apiData, 'admission_type_id'),
        })

        if (affectation) {
            stay.currentAffectation = new AffectationApiAdapter().createClass(affectation)
        }
        if (admissionType) {
            stay.admissionType = new AdmissionTypeApiAdapter().createClass(admissionType)
        }

        return stay
    }
}
